export default __webpack_public_path__ + "static/qt-sweetcombe-marque-3-star-silver-rgb-19060b059dc56d31027d528ca344fef8.png";